import { AdditionalFilterOption } from './constants';
import { type FlagFilters } from './records/FlagFilters';

export const clearFilterEnvIfNeeded = (filters: FlagFilters) => {
  let updatedFilters = filters;
  if (
    updatedFilters.status === '' &&
    updatedFilters.evaluated === undefined &&
    updatedFilters.creationDate === undefined
  ) {
    updatedFilters = updatedFilters.delete(AdditionalFilterOption.ENVIRONMENT);
  }
  return updatedFilters;
};
